export class PagedGettyOrderDetail {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: any[] = [];
}
